<template>
  <div class="animated fadeIn" v-if="me && me.subscription">
    <br />
    <b-modal v-if="me && me.subscription" v-model="showModal" hide-footer>
      Você tem <b>{{me.subscription.credits}}</b> créditos. Se iniciar a edição deste {{templateName}} ficará com <b>{{me.subscription.credits - 1}}</b> créditos.
      <br/>
      <br/>
      <br/>
      Tem certeza de que quer iniciar esta edição?
      <b-row>
        <b-col>
          <b-button class="mt-3 bg-success" block @click="showModal = false">User crédito</b-button>
        </b-col>
        <b-col>
          <b-button class="mt-3 bg-warning" block @click="showModal = false">Voltar</b-button>
        </b-col>
      </b-row>
      <br/>
      <br/>
      <b-row>
        <b-col>
          Para saber mais sobre créditos e validades, <a href="#">clique aqui</a>.
        </b-col>
      </b-row>
    </b-modal>
    <b-row>
      <b-col md="5">
        <b-alert show variant="danger" id="box" v-if="isAdmin && !isMine && template && !template.approved" class="text-center">
          <b>ESTE SLEEKER NÃO FOI APROVADO PELO REVISOR</b>
        </b-alert>
        <b-card>
          <div slot="header">{{isMine ? "Visualização" : "Pré-Visualização"}}</div>
          <b-form style="text-align: center;" v-if="template.videoPreview">
            <video style="max-height: 420px;" controls>
              <source :src="template.videoPreview" type="video/mp4">
            </video>
          </b-form>
          <b-form style="text-align: center;" v-else-if="template.story == true">
            <img
              v-if="(!me || !me.subscription || me.subscription.status != 1 || me.subscription.isExpired) && !isMine"
              style="max-height: 420px;"
              v-bind:src="template && template.watermarkedNeutral ? template.watermarkedNeutral : template.watermarked ? template.watermarked : template.thumbnail"
            />
            <img v-else style="max-height: 420px;" v-bind:src="template.fullImage" />
          </b-form>
          <b-form v-else>
            <img
              v-if="(!me || !me.subscription || me.subscription.status != 1 || me.subscription.isExpired) && !isMine"
              style="width: 100%;"
              v-bind:src="template && template.watermarkedNeutral ? template.watermarkedNeutral : template.watermarked ? template.watermarked : template.thumbnail"
            />
            <img v-else style="width: 100%;" v-bind:src="template.fullImage" />
          </b-form>
          <b-row
            v-if="template && template.customColors && !template.directDownload"
          >
            <b-col lg="12">
              <div class="text-center">
                Esta versão é apenas para colorir. Usar link original.<br/><br/>https://sleeker.pt/design/preview/{{template.originalTemplateId}}
              </div>
            </b-col>
          </b-row>
          <b-row
            v-else-if="canUseBecauseItsChallenge()"
          >
            <b-col md="12">
              <br />
              <div class="text-center">
                <b-button variant="primary" v-on:click="expressEdition">
                  <i class="fa fa-rocket"></i> Usar Agora
                </b-button>
              </div>
            </b-col>
          </b-row>
          <b-row
            v-else-if="isMine && me && me.subscription && !me.subscription.isExpired && !template.directDownload"
          >
            <b-col lg="12">
              <div class="text-center">
                <b-button variant="primary" v-on:click="expressEdition">
                  <i class="fa fa-rocket"></i> Editar Meu {{templateName}}
                </b-button>
              </div>
            </b-col>
          </b-row>
          <b-row
            v-else-if="isMine && me && me.subscription && me.subscription.isExpired && !template.directDownload"
          >
            <b-col lg="12">
              <div class="text-center">
                <b-button variant="primary" v-on:click="goToPayments">
                  <i class="fa fa-shopping-cart"></i> Renove seu plano para editar
                </b-button>
                <div class="text-muted font-weight-bold small">Clique para ser premium!</div>
              </div>
            </b-col>
          </b-row>
          <b-row
            v-else-if="(me && me.subscription && me.subscription.credits == 0 && me.subscription.status == 0) && !template.directDownload"
          >
            <b-col lg="12">
              <div class="text-center">
                <b-button variant="primary" v-on:click="expressEdition" v-if="!forbiddenEdition">
                  <i class="fa fa-rocket"></i> Usar crédito e editar
                </b-button>
                <b-alert variant="warning" v-if="forbiddenEdition" show><b>Enviamos um e-mail para confirmar seu cadastro</b> (lembre-se de verificar também na caixa de spam). <br/>Se o e-mail não chegou, <a v-bind:href="'https://api.whatsapp.com/send?phone=' + supportWhatsapp" target="_blank">clique aqui</a> e fale com nosso suporte!.</b-alert>
              </div>
            </b-col>
          </b-row>
          <b-row
            v-else-if="(me && me.subscription && (me.subscription.isExpired || me.subscription.credits <= 0) && me.subscription.status == 2 && !isFreeUseAllowed(template)) && !isMine"
          >
            <b-col lg="12">
              <div class="text-center">
                <b-button variant="primary" v-on:click="goToPayments">
                  <i class="fa fa-shopping-cart"></i> Seu teste acabou
                </b-button>
                <div class="text-muted font-weight-bold small">Clique para ser premium!</div>
              </div>
            </b-col>
          </b-row>
          <b-row
            v-else-if="me && me.subscription && (me.subscription.isExpired || !me.subscription.credits) && me.subscription.status == 3 && !isFreeUseAllowed(template)"
          >
            <b-col lg="12">
              <div class="text-center">
                <b-button variant="primary" v-on:click="goToPayments">
                  <i class="fa fa-shopping-cart"></i> Renove seu plano para continuar editando
                </b-button>
                <div class="text-muted font-weight-bold small">Clique para renovar!</div>
              </div>
            </b-col>
          </b-row>
          <b-row
            v-else-if="me && me.subscription && me.subscription.isExpired && me.subscription.status == 1"
          >
            <b-col lg="12">
              <div class="text-center">
                <b-button variant="primary" v-on:click="goToPayments">
                  <i class="fa fa-shopping-cart"></i> Sua assinatura expirou
                </b-button>
                <div class="text-muted font-weight-bold small">Clique para renovar!</div>
              </div>
            </b-col>
          </b-row>
          <b-row
            v-else-if="me && me.subscription && ((!me.subscription.isExpired && (me.subscription.status == 1)) || (me.subscription.credits > 0 && me.subscription.status == 0) || (!me.subscription.isExpired && me.subscription.credits && me.subscription.status == 3 )) && !template.directDownload"
          >
            <b-col md="12">
              <br />
              <div class="text-center">
                <b-button variant="primary" v-on:click="expressEdition">
                  <i class="fa fa-rocket"></i> Usar Agora
                </b-button>
              </div>
            </b-col>
          </b-row>
          <b-row
            v-else-if="(me.subscription.status == 2 && me.subscription.credits > 0 && !me.subscription.isExpired) && !isFreeUseAllowed(template) && !template.directDownload"
          >
            <b-col md="12">
              <br />
              <div class="text-center">
                <b-button variant="primary" v-on:click="expressEdition" v-if="!forbiddenEdition && !template.directDownload">
                  <i class="fa fa-rocket"></i> Usar crédito e editar
                </b-button>
                <b-alert variant="warning" v-if="forbiddenEdition" show><b>Enviamos um e-mail para confirmar seu cadastro</b> (lembre-se de verificar também na caixa de spam). <br/>Se o e-mail não chegou, <a v-bind:href="'https://api.whatsapp.com/send?phone=' + supportWhatsapp" target="_blank">clique aqui</a> e fale com nosso suporte!.</b-alert>
              </div>
            </b-col>
          </b-row>
          <b-row
            v-else-if="isFreeUseAllowed(template)"
          >
            <b-col md="12">
              <br />
              <div class="text-center">
                <b-button variant="primary" v-on:click="expressEdition(true)" v-if="!forbiddenEdition && !template.directDownload">
                  <i class="fa fa-rocket"></i> Usar gratuitamente
                </b-button>
                <b-alert variant="warning" v-if="forbiddenEdition" show><b>Enviamos um e-mail para confirmar seu cadastro</b> (lembre-se de verificar também na caixa de spam). <br/>Se o e-mail não chegou, <a v-bind:href="'https://api.whatsapp.com/send?phone=' + supportWhatsapp" target="_blank">clique aqui</a> e fale com nosso suporte!.</b-alert>
              </div>
            </b-col>
          </b-row>
          <br/>
          <b-row
            v-if="template && template.customColorsVersion && ((me.subscription && !me.subscription.isExpired && me.subscription.credits >= 0) || canUseBecauseItsChallenge()) && !template.directDownload">
            <b-col lg="12">
              <div class="text-center">
                <b-button variant="success" v-on:click="chooseColor()">
                  <i class="fa fa-pencil"></i> Escolher cor antes de usar
                </b-button>
              </div>
            </b-col>
          </b-row>
          <b-row
            v-if="!isMine && isAdmin && template && !template.customColors && !template.customColorsVersionFromOriginal && !template.directDownload">
            <b-col lg="12">
              <div class="text-center">
                <b-button style="background-color: #fa1d87; color: white;" v-on:click="expressEdition({ customColors: true })">
                  <i class="fa fa-pencil"></i> Criar Versão Colorida
                </b-button>
              </div>
            </b-col>
          </b-row>
          <b-row
            v-if="isMine || (template.directDownload && me && me.subscription && !me.subscription.isExpired)">
            <b-col lg="12">
              <div class="text-center">
                <button
                  v-bind:href="template.fullImage"
                  @click.prevent="downloadItem((template.directDownload ? template.directDownload : template.fullImage))"
                  v-if="!isIOS"
                  class="btn btn-block btn-outline-primary bg-white m-t"
                  download
                >
                  <i class="fa fa-download"></i>

                  &nbsp; {{(!downloadingFile) ? ('Baixar ' + templateName) : "Aguarde..."}}
                </button>
                <button
                  v-bind:href="template.fullImage"
                  v-else-if="isIOS && template.directDownload"
                  class="btn btn-block btn-outline-primary bg-white m-t share-button"
                  download
                >
                  <i class="fa fa-download"></i> 
                  <i class="fa fa-share" style="margin-left: 5px;"></i>
                  &nbsp; Baixar ou Compartilhar
                </button>
                <button
                  v-else-if="isIOS"
                  disabled
                  class="btn btn-block btn-outline-primary bg-white m-t"
                  type="button"
                >
                  <i class="fa fa-download"></i>
                  &nbsp; Aperte e segure na imagem para salvar
                </button>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col md="6">
        <b-row md="6"  v-if="template">
          <b-col sm="12">
            <related-posts v-model="selectedTemplate" :isTemporary="false"/>
          </b-col>
        </b-row>
        <b-card>
          <div
            slot="header"
          >{{isMine ? "Editar " + templateName : "Informações do " + templateName}} {{me && me.admin && template && template.weight ? " - Relevância: " + template.weight : ""}} {{me && me.admin && template && template.color ? " - Cor: " + template.color : ""}} {{me && me.admin && template && template.RGB ? " - RGB: " + template.RGB.red + ", " + template.RGB.green + ", " + template.RGB.blue : ""}}</div>
          <div class="callout callout-success">
            <span>{{isMine ? "Categorias do autor" : "Categorias"}}</span>
            <br />
            <span class="h6" v-for="item in categoriesTemplate" v-bind:key="item._id">
              <i class="fa fa-tag"></i>
              &nbsp; {{item.name}} &nbsp;
            </span>
            <div class="chart-wrapper">
              <canvas id="sparkline-chart-4" width="100" height="30"></canvas>
            </div>
          </div>

          <subtitle-box :subtitle="template.subtitle" :instructions="template.instructions" :preventSelection="me.subscription.isExpired && !isMine && !canUseBecauseItsChallenge()" :preventCopyButton="me && (!me.subscription || me.subscription.status == 0 || me.subscription.status == 2)"/>

          <div v-if="isMine">
            <b-row style="justify-content: center !important;">
              <b-col sm="12">
                <b-form>
                  <b-form-group label="Minhas categorias:">
                    <multiselect
                      v-model="selectedCategories"
                      class="background-multiSelect"
                      placeholder="Selecione uma categoria"
                      label="name"
                      track-by="_id"
                      :options="categoriesList"
                      :multiple="true"
                      :taggable="true"
                      :select-label="'Selecionar'"
                      :deselect-label="'Remover'"
                      :selected-label="'Selecionado'"
                      :tagPlaceholder="'Enter para criar uma nova categoria'"
                      @tag="addTag"
                    ></multiselect>
                  </b-form-group>
                </b-form>
              </b-col>
              <b-button
                style="margin-top: 35px !important;"
                type="button"
                v-on:click="saveCategoriesMine"
                variant="primary"
              >
                <i class="fa fa-save fa-lg"></i> Salvar Categorias
              </b-button>
            </b-row>
          </div>
          <br />
          <b-row v-if="isAdmin" style="margin-top: 5px !important;">
            <b-col lg="12">
              <div class="text-center">
                <b-button variant="primary" v-on:click="editTemplate">
                  <i class="fa fa-save"></i> Editar Template
                </b-button>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="isAdmin && template && template.creation" style="margin-top: 5px !important;">
            <b-col lg="12">
              <div class="text-center">
                <b-button variant="primary" v-on:click="goToCreation">
                  <i class="fa fa-eye"></i> Ver Creation
                </b-button>
              </div>
            </b-col>
          </b-row>
          <br />
          <br />
          <br />
        </b-card>
      </b-col>
      
    </b-row>
  </div>
</template>

<script>
import service from "./../service";
import Multiselect from "vue-multiselect";
import config from "../config";
import { isMobile } from "mobile-device-detect";
import SubtitleBox from "./SubtitleBox"
import RelatedPosts from "./RelatedPosts"
import axios from "axios";
import { isIOS } from "mobile-device-detect";

export default {
  name: "DesignPreview",
  props: [
    'isMine', 'idTemplate', 'value'
  ],
  data() {
    return {
      selectedCategories: [],
      taggingSelected: null,
      categoriesList: [],
      categoriesTemplate: [],
      template: {},
      config: config,
      me: undefined,
      isMobile: isMobile,
      confirmationEmailResent: false,
      selectedTemplate: this.value,
      forbiddenEdition: false,
      showModal: false,
      downloadingFile: false,
      challenge: "",
      isIOS: isIOS
    };
  },
  watch: {
    selectedTemplate () { 
      this.$emit('input', this.selectedTemplate)
    },
  },
  computed: {
    templateName() {
      return localStorage.templateName;
    },
    supportWhatsapp() {
      return localStorage.supportWhatsapp;
    },
    whitelabelName() {
      return localStorage.whitelabelName;
    },
    isAdmin: function() {
      return localStorage.admin;
    },
    subtitle: function() {
      if (this.template && this.template.subtitle) {
        this.template.subtitle = this.template.subtitle.replace(new RegExp("\n \n", 'g'), "\n\n");
        let urlEncoded = encodeURI(this.template.subtitle);
        
        let urlEnocdedNew = urlEncoded.replace(new RegExp("%0A", 'g'), "%E2%81%A3%0A");
        
        let finalSubtitle =  decodeURI(urlEnocdedNew);
        
        return finalSubtitle;
      }
      return false;
    }
  },
  methods: {
    attachActionToDownloadButton() {
      let vm = this;
      const shareButton = document.querySelector('.share-button');

      if (shareButton) {
        shareButton.addEventListener('click', async event => {
          vm.showDownloadingModal = true;
          fetch(vm.template.directDownload).then((result) => {
              result.blob().then(blob => {
                  let outputVideo = new File([blob], "video.mp4", { type: "video/mp4" });
                  navigator.share({
                      files: [outputVideo]
                  });

                  vm.showDownloadingModal = false;
              });
            });
        });
      } else {
        setTimeout(this.attachActionToDownloadButton, 200);
      }
    },
    downloadItem(url) {
      this.downloadingFile = true;
      let isVideo = false;
      let extension = url.split("?")[0].split(".")[url.split(".").length - 1];
      console.log("URL: " + url);
      axios
        .get(url + "?sada=sadaasdas", { responseType: "blob" })
        .then(({ data }) => {
          let type = "image/png";

          if (extension.indexOf("mp4") >= 0) {
            type = "video/mp4";
            isVideo = true;
          }

          if (isVideo) {
            service.useCredits(this.idTemplate).then(
              response => {
                if (response.status == "ok") {
                  const blob = new Blob([data], { type: type });
                  let link = document.createElement("a");
                  link.href = window.URL.createObjectURL(blob);
                  link.download = localStorage.whitelabelName + Math.floor(Math.random() * 10000) + "." + extension;
                  link.click();
                  this.downloadingFile = false;

                  // Create the event
                  var event = new CustomEvent("update-me", {});

                  // Dispatch/Trigger/Fire the event
                  document.dispatchEvent(event);
                }
              });
          } else {
            const blob = new Blob([data], { type: type });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = localStorage.whitelabelName + "." + extension;
            link.click();
            this.downloadingFile = false;
          }
        })
        .catch(error => console.error(error));
    },
    canUseBecauseItsChallenge: function () {
      if (this.me && new Date(this.me.challengeAccess) > new Date() && (this.template.categories && (this.template.categories.indexOf("611a670566172f354c21fe5b") >= 0 || this.template.categories.indexOf("611a6f1366172f354c21ff66") >= 0))) {
        return true;
      }
    },
    saveCategoriesMine: function() {
      if (this.selectedCategories || this.selectedCategories.length > 0) {
        service
          .saveCategoriesMine(this.selectedCategories, this.template._id)
          .then(
            response => {
              this.loadInfo();
            },
            () => {}
          );
      }
    },
    addTag: function(newTag) {
      const tag = {
        name: newTag
      };
      this.categoriesList.push(tag);
      this.selectedCategories.push(tag);
    },
    getAllCategories: function() {
      return fetch(baseURL + "categories", {
        method: "GET"
      }).then(function(response) {
        if (response && response.status && response.status === 200) {
          return response.json();
        } else {
          return Promise.reject();
        }
      });
    },
    chooseColor: function() {
      console.log(this.template.customColorsVersion);
      if (this.me.emailConfirmationTime || this.me.subscription.status != 2) {
        let params = {id: this.template.customColorsVersion};

        if (this.challenge) {
          params.challenge = this.challenge;
        }

        this.$router.push({name: "ChooseColor", params: params});
      } else {
        this.forbiddenEdition = true;
      }
    },
    expressEdition: function(options) {
      if (this.me.emailConfirmationTime || this.me.subscription.status != 2) {
        service.useTemplate(this.template._id).then(
          response => {
            let params = { firstEdition: false, shouldAllow: true }

            if (response.firstEdition) {
              params.firstEdition = true;
            }

            if (options && options.customColors) {
              params.customColors = true;
            }

            if (this.challenge) {
              params.customSavingUrl = "/design/save/{temporaryId}?challenge=" + this.challenge
            }

            this.$router.push({ name: 'Editor', params: params});
            
            // Create the event
            var event = new CustomEvent("update-me", {});

            // Dispatch/Trigger/Fire the event
            document.dispatchEvent(event);
          },
          () => {
            this.showError = true;
          }
        );
      } else {
        this.forbiddenEdition = true;
      }
    },
    isFreeUseAllowed(template) {
      if (template.freeUseAllowed && this.me && (this.me.subscription.status == 0 || this.me.subscription.status == 2)) {
        return true;
      } else if (template.freeVIPUseAllowed && this.me && this.me.vip) {
        return true;
      } else if (template.freePremiumUseAllowed && this.me && (this.me.subscription.status == 1 || this.me.subscription.status == 3)) {
        return true;
      }
      return 
    },
    goToCreation: function() {
      this.$router.push("/admin/creation/update/" + this.template.creation);
    },
    editTemplate: function() {
      this.$router.push("/design/edit/" + this.idTemplate);
    },
    saveImg() {
      const dataUrl = this.template.fullImage;

      var xhr = new XMLHttpRequest();
      xhr.onload = function() {
        var reader = new FileReader();
        reader.onloadend = function() {
          let base64Img = reader.result;
          let a = document.createElement("a");
          a.href = base64Img;
          a.download = localStorage.whitelabelName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", dataUrl);
      xhr.responseType = "blob";
      xhr.send();
    },
    resendConfirmationEmail: function() {
      service.resendConfirmationEmail().then(
        response => {
          this.confirmationEmailResent = true;
        },
        () => {
          this.showError = true;
        }
      );
    },
    goToPayments: function() {
      this.$router.push("/payments/");
    },
    loadInfo: function() {
      service.getTemplateUserCategories(this.idTemplate).then(
        response => {
          this.selectedCategories = response;
        },
        () => {
          this.showError = true;
        }
      );

      service.getTemplateCategories(this.idTemplate).then(
        response => {
          this.categoriesTemplate = response;
        },
        () => {
          this.showError = true;
        }
      );
    }
  },
  created: function() {
    if (this.$route.query.challenge) {
      this.challenge = this.$route.query.challenge;
    }

    service.getMe().then(
      response => {
        this.me = response;
      },
      () => {
        this.showError = true;
      }
    );
    this.selectedTemplate = this.idTemplate;
    service.getTemplateById(this.idTemplate).then(
      response => {
        this.template = response.template;
        if (this.isIOS && this.template.directDownload) {
          this.attachActionToDownloadButton();
        }
      },
      () => {
        this.showError = true;
      }
    );
    if (!this.isMine) {
      service.getAllCategories().then(
        response => {
          this.categoriesList = response;
        },
        () => {
          this.showError = true;
        }
      );
    } else {
      service.getUserCategories().then(
        response => {
          this.categoriesList = response;
        },
        () => {
          this.showError = true;
        }
      );
    }

    this.loadInfo();
  },
  components: { Multiselect, SubtitleBox, RelatedPosts }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



<style lang="css" scoped>
.background-multiSelect >>> .multiselect__tag {
  background: #20a8d8 !important;
}
</style>


<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
